/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { DocumentTitle } from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { Trans } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

const TechnicalWorks = () => {
    const location = useLocation();
    const { workplaceSettings, generalTechnicalWork } = useGeneralSettingsContext();

    const settings = workplaceSettings.find((x) => x.path === location.pathname);

    const isBlocked = settings || generalTechnicalWork;

    return isBlocked ? (
        <DocumentTitle code={generalTechnicalWork ? '' : `BackOffice${settings?.translateCode}`}>
            <div className="text-center">
                <h3>
                    <Trans i18nKey="BackOfficeTechnicalWorks" />
                </h3>
                <span lang="ja">¯\_(ツ)_/¯</span>
            </div>
        </DocumentTitle>
    ) : (
        <Outlet />
    );
};

export default TechnicalWorks;
